import React from 'react'


function Button(props) {
    return (
        <button type='button' className={`border border-sky-300 py-[6px] mt-1 pl-6 pr-5 font-light flex hover:text-sky-500 hover:border-sky-500 transition-colors ease-in-out duration-200 ${props.classname}`} onClick={props.click}>{props.title}{props.icon}</button>
    )
}

export default Button